// import { useContext } from "react";
// import { createContext } from "react";
import { useSelector } from "react-redux";


// const privilagesContext = createContext();
// export const useAuth = () => {
//   console.log(privilagesContext,"privilagesContextprivilagesContextprivilagesContext");
  
//   const context = useContext(privilagesContext);
//   if (!context) {
//     throw new Error("useAuth must be used within an AuthProvider");
//   }
//   return context;
// }; 

export const CommonPrivFilter = (moduleId) => {
  const {privileges,userType}=useSelector((state)=>state.privilegeSlice)

  console.log(userType);
  

  const filteredObj = privileges?.find((dat) => dat?.unique_id === moduleId);

  return {
    canRead:filteredObj?.read === 1,
    canCreate: filteredObj?.create === 1,
    canUpdate:filteredObj?.update === 1,
    canDelete:filteredObj?.delete === 1,
    canPrint:filteredObj?.print === 1,
        canAttach:filteredObj?.attach === 1
  };
};
//  export default privilagesContext


export function filterMenu(menu) {
  const predicate = (item) => !item.ref || CommonPrivFilter(item.ref)?.canRead;

  const filtered = menu
    .map((item) => {
      const matches = predicate(item);

      // Recursively filter children if any
      let filteredChildren = [];
      if (Array.isArray(item.children)) {
        filteredChildren = filterMenu(item.children);
      }

      // Include item if:
      // - it matches, OR
      // - it has matching children
      if (matches) {
        return {
          ...item,
          children: filteredChildren?.length > 0 ? filteredChildren : undefined,
        };
      }

      // Otherwise exclude it
      return null;
    })
    .filter(Boolean); // Remove nulls

  console.log(filtered, "Filtered Menu");
  return filtered;
}
